<ul>
  <span class="hideMenuBtn" (click)="hideMenu()">
    <img src="../../../../../assets/icons/cancel-icon.svg" />
  </span>

  <img
    [class]="profile?.thirdPartyOwner === 'rextie' ? 'big-logo-rextie' : 'big-logo'"
    [src]="profile?.thirdPartyOwner === 'rextie' ? '../../../../../assets/logos/rextie.svg' : '../../../../../assets/logos/small.png'"
  />

  <ng-container *ngFor="let item of menuItems; let i = index">
    <ng-container *allowedRoles="item.allowedRoles">
      <app-side-menu-item
        *ngIf="isMenuItemVisible(item)"
        [item]="item"
        [key]="i"
        [class]="isActive(item.target)"
        [disabled]="isItemDisabled(item)"
        (clicked)="clicked($event, item)"
      >
      </app-side-menu-item>
    </ng-container>
  </ng-container>
</ul>
